const counterUp = window.counterUp.default
const counterCallback = entries => {
	entries.forEach( entry => {
		const el = entry.target
		if ( entry.isIntersecting )  {
			counterUp( el, {
				duration: 2000,
				delay: 30,
			} )
		}
	} )
}

const IO = new IntersectionObserver( counterCallback, { threshold: 1 } )

const numberElements = document.getElementsByClassName('number-value')
for(el of numberElements){
    IO.observe( el )
}